export default {
  weight: 'وزن',
  deleted: 'حذف شده',
  changesWillBeLost: 'تغییرات شما هنوز ذخیره نشده است. ایا مطمئن هستید؟',

  yourProgress(progress: string) {
    return `پیشرفت کار شما: ${progress}%`;
  },
  onlyVerifierCanMark: 'فقط تأییدکننده می‌تواند وضعیت را تغییر دهد',
  chooseVerifyStatus(customTitle?: string) {
    if (customTitle) {
      return `وضعیت ${customTitle} را انتخاب نمایید:`;
    }
    return 'وضعیت تأیید را انتخاب نمایید:';
  },
  status: 'وضعیت: ',
  draft: 'پیش‌نویس',
  archived: 'بایگانی شد',
  projectArchived: 'پروژه بایگانی شده',
  complete: 'اجرا شده',
  incomplete: 'ناتمام',
  started: 'در حال بررسی',
  notStarted: 'انجام نشده',
  rejected: 'رد شده',
  save: 'ذخیره',
  verifyStatus(
    status: string,
    verifierNotStartedTitle: string,
    verifierStartedTitle: string,
    verifierCompleteTitle: string,
    verifierRejectTitle: string
  ) {
    const notStartedTitle = verifierNotStartedTitle
      ? verifierNotStartedTitle
      : 'شروع نشده';
    const startedTitle = verifierStartedTitle
      ? verifierStartedTitle
      : 'در حال بررسی';
    const completeTitle = verifierCompleteTitle
      ? verifierCompleteTitle
      : 'تأیید شده';
    const rejectTitle = verifierRejectTitle ? verifierRejectTitle : 'رد شده';
    switch (status) {
      case 'complete':
        return completeTitle;
      case 'notStarted':
        return notStartedTitle;
      case 'started':
        return startedTitle;
      case 'rejected':
        return rejectTitle;
      default:
        return 'هنوز مشخص نشده';
    }
  },
  taskWeight: 'وزن وظیفه',
  progressChangingIsLocked: 'تغییر وضعیت قفل شده است',
  progressChangeNotAvailableOnDraftTask:
    'امکان ثبت وضعیت در حالت پیشنویس وجود ندارد',
  mainProgress: (mainProgressTitle: string) =>
    mainProgressTitle ? mainProgressTitle : 'پیشرفت اصلی',
  secondaryProgress: (secondaryProgressTitle: string) =>
    secondaryProgressTitle ? secondaryProgressTitle : 'پیشرفت فرعی',
};
